import React from "react";
import { ISignatureInputComponent } from "interfaces/sw/SWInterfaces";
import { useDispatch } from "react-redux";
import { updateSignatureInput } from "store/manageSW/manageSWActions";
import "./ComponentEditor.scss";

interface ISignatureInputEditorProps {
  signatureInput: ISignatureInputComponent,
  allowEdit: boolean,
  stepGuid: string,
  labelText: string,
}

const SignatureInputEditor: React.FC<ISignatureInputEditorProps> = ({
  signatureInput,
  allowEdit,
  stepGuid,
  labelText,
}) => {
  const dispatch = useDispatch();

  return (
    <div className="component-editor">
      <label className="mandatory block">{labelText}</label>
      {allowEdit &&
        <input
          type="text"
          defaultValue={signatureInput.label}
          onBlur={(e) => dispatch(updateSignatureInput({
            stepGuid,
            component: {
              ...signatureInput,
              label: e.target.value,
            },
          }))}
        />
      }
      {!allowEdit &&
        <span>{signatureInput.label}</span>
      }
    </div>
  );
}

export default SignatureInputEditor;